import React from "react";
import styled from "@emotion/styled";
import Slider from "./interactiveMapPage/gallery/Slider";
import imageOne from "../3-assets/images/bali/mountbatur/sunrise-right.jpg";
import imageTwo from "../3-assets/images/bali/banyumala/waterfall-horizontal.jpg";

export default function Test() {
  return (
    <Container>
      <Slider>
        {[imageOne, imageTwo, imageOne, imageTwo, imageOne, imageTwo, imageOne, imageTwo].map(i => (
          <Image src={i} />
        ))}
      </Slider>
    </Container>
  );
}

const Container = styled.div`
  color: turquoise;
  width: 100vw;
  height: 100vh;
`;

const Image = styled.img`
  width: 40vw;
  @media (max-width: 600px) {
    width: 100vw;
  }
`;
